// extracted by mini-css-extract-plugin
module.exports = {"Container":"General_Container__2fKrI","usersInfo":"General_usersInfo__UmApN","walletStatus":"General_walletStatus__3whJq"};